import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';
import { SharedDataService } from '../services';
import { HOME_PATH, LANDING_PATH } from '../constants';

const ROUTES = {
  verifyProfile: '/verify-profile'
};

export const verifyprofileguardGuard: CanActivateFn = (route, state) => {
  const storageService = inject(StorageService);
  const user = storageService.getUserInformation();
  const router = inject(Router);

  if (user && user.firstLogin == true) {
    router.navigate([LANDING_PATH]);
    return false;
  } else {
    return true;
  }
};
